<app-nav-bar></app-nav-bar>

<div *ngIf="userHasAdminPermissions(boardUser)" class="admin-token-container">
    <div class="token-card">
        <!-- Header -->
        <div class="token-header">
            <div class="header-content">
                <h1 class="token-title">Admin Token Management</h1>
                <p class="token-subtitle">Update your admin authentication token securely</p>
            </div>
            <div class="header-icon">🔐</div>
        </div>

        <!-- Form -->
        <form class="token-form">
            <!-- Token Input -->
            <div class="form-field">
                <label for="token" class="form-label">
                    <span class="label-text">New Admin Token</span>
                    <span class="required-badge">Required</span>
                </label>
                <div class="input-wrapper">
                    <input 
                        #token 
                        type="password" 
                        class="form-input"
                        id="token" 
                        placeholder="Enter your new admin token"
                        autocomplete="off">
                    <span class="input-icon">🔑</span>
                </div>
                <p class="input-hint">Your token should be at least 8 characters long</p>
            </div>

            <!-- Confirm Token Input -->
            <div class="form-field">
                <label for="confirmToken" class="form-label">
                    <span class="label-text">Confirm Admin Token</span>
                    <span class="required-badge">Required</span>
                </label>
                <div class="input-wrapper">
                    <input 
                        #confirmToken 
                        type="password" 
                        class="form-input"
                        id="confirmToken" 
                        placeholder="Re-enter your admin token"
                        autocomplete="off">
                    <span class="input-icon">🔑</span>
                </div>
                <p class="input-hint">Tokens must match exactly</p>
            </div>

            <!-- Alerts -->
            <div *ngIf="error" class="alert alert-error">
                <span class="alert-icon">⚠️</span>
                <span class="alert-text">{{ error }}</span>
            </div>
            <div *ngIf="successMessage" class="alert alert-success">
                <span class="alert-icon">✅</span>
                <span class="alert-text">{{ successMessage }}</span>
            </div>

            <!-- Button -->
            <button 
                class="btn btn-primary" 
                type="button" 
                (click)="save(token.value, confirmToken.value)">
                <span class="btn-icon">💾</span>
                <span class="btn-text">Save Token</span>
            </button>

            <!-- Security Note -->
            <div class="security-note">
                <p class="security-note-title">🛡️ Security Best Practices</p>
                <ul class="security-list">
                    <li>Use a strong, unique token</li>
                    <li>Keep your token confidential</li>
                    <li>Change it regularly for security</li>
                    <li>Don't share it with unauthorized users</li>
                </ul>
            </div>
        </form>
    </div>
</div>